import {Injectable} from '@angular/core';
import {MatSnackBar, MatSnackBarConfig, MatSnackBarRef} from '@angular/material';
import {ApiService} from './api.service';
import {BaseService} from './base.service';
import {Product} from '../model/Entities/Product';
import {Contract} from '../model/Entities/Contract';
import {Filter} from '../model/Helpers/Filter';
import { SortInfo } from "../model/Helpers/SortInfo";
import {Document} from '../model/Entities/Document';

@Injectable()
export class PrintService extends BaseService {
    getContractPrintUrl(c: Contract): string {
        if (!c || !c.id) {
            return "";
        }

        return this.apiRoot + `/files/contracts/${c.id}`;
    }

    getContractExportLabelPrintUrl(c: Contract): string {
        if (!c || !c.id) {
            return "";
        }

        return this.apiRoot + `/files/contract-export-label/${c.id}`;
    }

    getProductLabelsPrintUrl(
        items: Number[],
        count: Number = 1,
        offset: Number = 0
    ): string {
        return (
            this.apiRoot +
            `/files/product-stickers?items=${items.join(
                ","
            )}&count=${count}&offset=${offset}`
        );
    }

    getInventoryCheckPrintUrl(date: Date): string {
        return (
            this.apiRoot + `/files/inventory-check?date=${date.toISOString()}`
        );
    }

    getContractsListPrintUrl(filters: Filter[]): string {
        return (
            this.apiRoot +
            `/files/contracts-list/1${this.getFiltersUrlQuery(filters)}`
        );
    }

    getContractsListReportPrintUrl(filters: Filter[]): string {
        return (
            this.apiRoot +
            `/files/contract-reports/1${this.getFiltersUrlQuery(filters)}`
        );
    }

    getDashboardPrintUrl(filters: Filter[], delivery = null): string {
        if (delivery !== null) {
            filters.push(new Filter("delivery", delivery));
        }
        return (
            this.apiRoot +
            `/files/dashboard/1${this.getFiltersUrlQuery(filters)}`
        );
    }

    getCustomersStatsPrintUrl(filters: Filter[]): string {
        return (
            this.apiRoot +
            `/files/customer-reports/1${this.getFiltersUrlQuery(filters)}`
        );
    }

    getRevenueReportPrintUrl(filters: Filter[]): string {
        return (
            this.apiRoot +
            `/files/revenue-reports/1${this.getFiltersUrlQuery(filters)}`
        );
    }

    getTransportsPrintUrl(filters: Filter[]): string {
        return (
            this.apiRoot +
            `/files/transports/1${this.getFiltersUrlQuery(filters)}`
        );
    }

    getRevenueReportXlsxUrl(filters: Filter[]): string {
        return (
            this.apiRoot +
            `/files/revenue-reports-xlsx/1${this.getFiltersUrlQuery(filters)}`
        );
    }

    getDocumentPrintUrl(id, lang?: string): string {
        let url = this.apiRoot + `/files/document-pdf/${id}`;
        if (lang) {
            url += `?lang=${lang}`;
        }
        return url;
    }
}



// WEBPACK FOOTER //
// /app/src/services/print.service.ts